import { render, staticRenderFns } from "./uploading-video.vue?vue&type=template&id=4b9adef0&scoped=true"
import script from "./uploading-video.vue?vue&type=script&lang=js"
export * from "./uploading-video.vue?vue&type=script&lang=js"
import style0 from "./uploading-video.vue?vue&type=style&index=0&id=4b9adef0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9adef0",
  null
  
)

export default component.exports